import { useFormik } from 'formik';
import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo1 from "../../assets/images/logo/logo-white.png";
import '../../index.css';
import showEye from "../../assets/images/logo/showEye.svg";
import hideEye from "../../assets/images/logo/hideEye.svg";
import { CreateNewPasswordScheme } from '../Components/Schemes/CreateNewPasswordScheme';
import Routes from '../Components/data/remote/Routes';
import { ToastContainer, toast } from 'react-toastify';
import { Puff } from 'react-loader-spinner';



const notify = (message, type) => {
  // alert('error', +message)
  type == "success" ? toast.success(message, {

    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: false,
    closeButton: false,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "colored",

  })
    :
    toast.error(message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: false,
      closeButton: false,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",

      style: {
        backgroundColor: '#D92533'
      }
    });
}
const ForgetPassword = () => {

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");


  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const location = useLocation();


  useEffect(() => {
    const emailProps = location.state.email;
    setEmail(emailProps)

  }, [])

  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
  const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const initialValues = {
    email: "",
    password: "",
    confirm_password: ""

  };

  const history = useNavigate();

  const { values, handleBlur, handleChange, handleSubmit, errors, touched } =
    useFormik({
      initialValues,
      validationSchema: CreateNewPasswordScheme,
      validateOnChange: true,
      validateOnBlur: false,
      //// By disabling validation onChange and onBlur formik will validate on submit.
      onSubmit: (values, action) => {
        setLoading(true);

        //Calling Login Api
        var formdata = new FormData();
        formdata.append("email", email);
        formdata.append("password", values.password);
        formdata.append("password_confirmation", values.confirm_password);

        var requestOptions = {
          method: 'POST',
          body: formdata,
          redirect: 'follow'
        };

        fetch(Routes.RESETPASSWORD, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status == true) {
              history("/success");
              notify(result.message, "success");
              setLoading(false);

            } else {
              notify(result.message, "error");
              setLoading(false);

            }

          })
          .catch(error => {
            console.log('error', error)
            setLoading(false);
          });
      },
    });
  return (
    <div className="container-fluid loginpage">
      <ToastContainer
      />
      {loading &&
        <div className="loaderScreen">
          <Puff
            height={80}
            width={80}
            color="rgba(0, 120, 207, 1)"
            ariaLabel="puff-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      }
      <div className="col-sd-3 col-md-6 col-lg-4  container card card-loginForget d-flex justify-content-center">
        <div style={{ textAlign: 'center', display: 'flex', justifyContent: "center", alignItems: 'center', textAlign: 'center' }}>
          <Link to={'/'} style={{ width: '50%' }}>
            <img src={logo1} className=" " alt="..." />
          </Link>
        </div>
        <Link to={'/'}><h5 className="card-title">AL Asab</h5></Link>
        <form onSubmit={handleSubmit} className="card-body" noValidate>
          <div className="login-text-area mt-3 ">
            <label for="validationDefaultEmail" className="form-label">
              <strong className="login-text">Enter Your Email</strong>
            </label>
            <input
              type="email"
              className="form-control loginEmailInput"
              id="validationDefaultEmail"
              placeholder="Your Email"
              required
              disabled
              name="email"
              value={email}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.email && touched.email ? (
              <p className="form-error">{errors.email}</p>
            ) : null}
          </div>
          <div className='forgetInputs login-text-area mt-3'>
            <label for="validationDefaultEmail" className="form-label">
              <strong className="login-text">Reset password </strong>
            </label>
            <input
              type={isPasswordVisible ? "text" : "password"}
              className="form-control loginPasswordInput"
              id="exampleFormControlInput1"
              name="password"
              placeholder="Reset password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <div className="eyeButton" onClick={togglePasswordVisibility}>
              {isPasswordVisible ? (
                <img width={20} src={showEye} />
              ) : (
                <img width={20} src={hideEye} />
              )}
            </div>
            {errors.password && touched.password ? (
              <p className="form-error">{errors.password}</p>
            ) : null}
          </div>

          <div className='forgetInputs login-text-area mt-3'>
            <label for="validationDefaultEmail" className="form-label">
              <strong className="login-text">Confirm Password </strong>
            </label>
            <input
              type={isConfirmPasswordVisible ? "text" : "password"}
              className="form-control loginPasswordInput"
              id="exampleFormControlInput1"
              name="confirm_password"
              placeholder="Confirm Password"
              value={values.confirm_password}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <div className="eyeButton" onClick={toggleConfirmPasswordVisibility}>
              {isConfirmPasswordVisible ? (
                <img width={20} src={showEye} />
              ) : (
                <img width={20} src={hideEye} />
              )}
            </div>
            {errors.confirm_password && touched.confirm_password ? (
              <p className="form-error">{errors.confirm_password}</p>
            ) : null}
          </div>




          <button className="login-button mt-4" type="submit">
            Submit
          </button>
          {/* <div className='d-flex justify-content-center'>
            <Link to="/">
              <button className="goback-button btn btn-primary mt-4" type="submit" >
                Go Back
              </button>
            </Link>
          </div> */}
        </form>
      </div>
    </div>
  );
};

export default ForgetPassword;